// With responseType 'blob' a non-2xx body arrives as a Blob, hiding the server's message.
export async function readBlobError(err: any): Promise<any> {
    const data = err?.response?.data;
    if (!(data instanceof Blob)) return err;

    try {
        const text = await data.text();
        try {
            const parsed = JSON.parse(text);
            return (
                parsed?.message ??
                parsed?.title ??
                parsed?.detail ??
                (typeof parsed === "string" ? parsed : text) ??
                err
            );
        } catch {
            return text || err;
        }
    } catch {
        return err;
    }
}

export function parseContentDispositionFileName(header: string | undefined, fallback: string): string {
    if (!header) return fallback;

    const star = /filename\*=UTF-8''([^;]+)/i.exec(header);
    if (star) {
        try {
            return decodeURIComponent(star[1]);
        } catch {
            /* fall through to the plain form */
        }
    }

    const plain = /filename="?([^"]+?)"?(?:;|$)/i.exec(header);
    return plain ? plain[1] : fallback;
}
